<template>
  <div class="container content-block">
    <div class="row header py-2" :class="questTypeClassBackground(quest.type)">
      <div class="container-fluid pl-0 pr-0">
        <div class="row">
          <div class="col">
            <!--            <div class="title" v-if="isSimpleMode">{{ questTypeToString(quest.type) }}</div>-->
            <!--            <div class="title" v-else>{{ quest.title }}</div>-->

            <div class="title">{{ quest.title }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col a">
            <span class="left">
              <span>
                <QuestTypeIcon class="quest-type-icon" :quest-type="quest.type"/>
                {{ questTypeToString(quest.type) }}
              </span>
            </span>
            <span class="right" v-if="quest.contentTheme!=='olympics'"></span>
            <span class="right">
              <span @click="toggleFavourite"><FavouriteIconEmpty v-if="!faved" class="favourite-icon mr-3"/>
              <FavouriteIconFilled v-if="faved" class="favourite-icon mr-3"/></span>
              {{ quest.points }}&nbsp;<BatteryLogo class="quest-points-icon mr-3"/>

            </span>

          </div>
        </div>
      </div>
    </div>
    <div class="row properties" v-if="quest.questProperties && !isSimpleMode">
      <div class="col">
        <ul class="fa-ul mb-0 quest-meta-data">
          <!--Quest properties-->
          <li v-if="quest.questProperties.intensity?.length > 0">
            <span class="fa-li">
              <QuestIntensityIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.intensity" :key="index">
                {{ questIntensityToString(item) }}
              </li>
            </ul>
          </li>
          <li v-if="quest.questProperties.duration?.length > 0">
            <span class="fa-li">
              <QuestDurationIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.duration" :key="index">
                {{ questDurationToString(item) }}
              </li>
            </ul>
          </li>
          <li v-if="quest.questProperties.location?.length > 0">
            <span class="fa-li">
              <QuestLocationIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.location" :key="index">
                {{ questLocationToString(item) }}
              </li>
            </ul>
          </li>
          <!--
          <li v-if="quest.questProperties.partOfDay.length > 0">
            <span class="fa-li">
              <QuestPartOfDayIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.partOfDay" :key="index">
                {{ questPartOfDayToString(item) }}
              </li>
            </ul>
          </li>
          -->
          <li v-if="quest.questProperties.material?.length > 0">
            <span class="fa-li">
              <QuestMaterialIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.material" :key="index">
                {{ questMaterialToString(item) }}
              </li>
            </ul>
          </li>
          <li v-if="quest.questProperties.subject?.length > 0">
            <span class="fa-li">
              <QuestSubjectIcon :class="questTypeClassFont(quest.type)"/>
            </span>
            <ul>
              <li v-for="(item, index) in quest.questProperties.subject" :key="index">
                {{ questSubjectToString(item) }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="row impulse-info" v-if="showImpulseInfo && isSimpleMode">
      <div class="col">
        <div class="mt-3 p-2">
          <div class="row explanation mt-3" v-if="quest.descriptionTeacher">
            <div class="col">
              <h3>Beschrijving voor de leerkracht</h3>
              <p class="quest-description">{{ quest.descriptionTeacher }}</p>
            </div>
          </div>
          <div class="row explanation mt-3" v-if="quest.descriptionStudent">
            <div class="col">
              <h3>Beschrijving voor de leerlingen</h3>
              <p class="quest-description">{{ quest.descriptionStudent }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row footer" v-if="enablePlanBtn">
      <div class="container">
        <v-button button-text="Activiteit inplannen" :class="[questTypeClass(quest.type), isSimpleMode ? 'my-4' : '']"
                  :enabled="true" @click="onPlanQuest" :disabled="!enablePlanBtn"></v-button>
      </div>
    </div>
    <div class="row" v-if="previousActivities && previousActivities.length > 0 && !isSimpleMode">
      <div class="col-12">
        <h6>
          Vorige speelbeurten <small>({{ previousActivities.length }})</small>
          <span class="float-right"><CollapseIcon class="collapse-indicator"/></span>
        </h6>
      </div>
      <div class="col-12">
        <ul>
          <li v-for="activity in previousActivities" :key="activity.id">
            {{ formatDateTime(activity.plannedDate) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import DateFormatter from "@/mixins/DateFormatter";
import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";
import {QuestTypeEnum} from "sandpiper_api";
import QuestTypeIcon from "@/components/icons/QuestTypeIcon";

// Icons
import QuestPropertyIcons from "@/mixins/QuestPropertyIcons";
import BatteryLogo from "@/assets/image/icons/quest/icon-activity_points.svg?inline";
import CollapseIcon from "@/assets/image/icons/icon-arrow-alternative.svg?inline";
import FavouriteIconEmpty from "@/assets/image/icons/icon_favourite_NEW.svg?inline";
import FavouriteIconFilled from "@/assets/image/icons/icon_favouriteclicked_NEW.svg?inline";


export default {
  name: "QuestSummaryPanel",
  components: {QuestTypeIcon, VButton, BatteryLogo, CollapseIcon, FavouriteIconEmpty, FavouriteIconFilled},
  mixins: [QuestTypeHelper, QuestPropertiesHelper, QuestPropertyIcons, DateFormatter],
  props: {
    quest: Object,
    previousActivities: Array,
    enablePlanBtn: {
      type: Boolean,
      default: true
    },
    showImpulseInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      questTypeEnum: new QuestTypeEnum(),
      faved: false,
    }
  },
  computed: {
    questType() {
      return this.quest?.type;
    },
    isSimpleMode() {
      return this.questType === this.questTypeEnum.impulse;
    },
  },
  methods: {
    onPlanQuest() {
      this.$emit("plan-quest");
    },
    checkFavourited() {
      let savedFaves = localStorage.getItem("BBUDfavourites");

      if (!savedFaves || !JSON.parse(savedFaves).includes(this.quest.id)) {
        this.faved = false;
      } else {
        this.faved = true;
      }
    },
    toggleFavourite() {
      let faves = JSON.parse(localStorage.getItem("BBUDfavourites"));
      if (!faves) {
        faves = [];
        faves.push(this.quest.id);
        this.faved = true;
      } else if (!faves.includes(this.quest.id)) {
        faves.push(this.quest.id);
        this.faved = true;
      } else {
        faves.splice(faves.indexOf(this.quest.id), 1);
        this.faved = false;
      }

      localStorage.setItem("BBUDfavourites", JSON.stringify(faves));

    }
  },
  mounted() {
    this.checkFavourited();
  }
}
</script>

<style lang="scss" scoped>
.header {
  color: $font-light;

  font-weight: 500;
  font-size: 1.25rem;

  padding: 0 25px;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.quest-type-icon {
  max-width: 16.5px;
  max-height: 16.5px;
  fill: $font-light;
  margin-right: 5px;
}


.title {
  font-size: 1.25rem;
  font-weight: 500;
}

.quest-points-icon {
  margin-left: 5px;
  fill: $font-light;
}

.quest-meta-data {
  > li:not(:first-child) {
    margin-top: 15px;
  }

  > li {
    ul {
      list-style: none;
      padding: 0;

      > li:not(:first-child) {
        margin-top: 5px;
      }
    }
  }
}

.a {
  display: flex;
  flex-direction: row;

  font-size: 0.875rem;

  .left {
    flex: 1;
    text-align: left;
  }

  .right {
    flex: 1;
    text-align: right;
  }
}

.properties {
  padding: 25px 0px;
}

.property-list {
  li {
    margin-bottom: 1rem;
  }

  .tag {
    margin-bottom: 0;
  }
}

.btn {
  margin-bottom: 1rem;
}

.collapse-indicator {
  svg {
    fill: $primary-blue;
  }
}

.favourite-icon {
  fill: white;
}
</style>